import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("verifying"); // verifying | active | timeout
  const [products, setProducts] = useState([]);
  const tries = useRef(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sid) { setState("timeout"); return; }
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/session/${sid}`);
        if (data.status === "ACTIVE") { setProducts(data.products || []); setState("active"); return; }
      } catch (e) { /* keep trying */ }
      tries.current += 1;
      if (tries.current > 15) { setState("timeout"); return; }
      if (!stop) setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sid]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#06080c] text-white p-6" data-testid="billing-success-page">
      <div className="w-full max-w-md rounded-2xl bg-[#0f131b] border border-white/10 p-8 text-center shadow-2xl">
        {state === "verifying" && (<><Loader2 className="h-10 w-10 animate-spin text-[#38bdf8] mx-auto mb-3" data-testid="bs-verifying" /><h1 className="text-xl font-bold mb-1">Confirming your payment…</h1><p className="text-white/50 text-sm">Please don't refresh or pay again — this only takes a moment.</p></>)}
        {state === "active" && (<><CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto mb-3" data-testid="bs-active" /><h1 className="text-2xl font-bold mb-1">You're all set!</h1><p className="text-white/60 text-sm mb-6">Your labs are now active{products.length ? `: ${products.join(", ")}` : ""}.</p><button onClick={() => navigate("/labs")} className="w-full h-11 rounded-lg bg-[#38bdf8] text-[#06121b] font-semibold" data-testid="bs-go-labs">Go to my labs</button></>)}
        {state === "timeout" && (<><AlertCircle className="h-10 w-10 text-amber-400 mx-auto mb-3" data-testid="bs-timeout" /><h1 className="text-xl font-bold mb-1">We're verifying your payment</h1><p className="text-white/50 text-sm mb-6">This can take a minute. Your labs will unlock automatically once confirmed — no need to pay again.</p><button onClick={() => navigate("/account/billing")} className="w-full h-11 rounded-lg bg-white/10 hover:bg-white/15 font-semibold">View my subscriptions</button></>)}
      </div>
    </div>
  );
}
